import request from "request";
import { logger, jsonToQuery } from "./helpers";
import { Event } from "../analytics";

const URL = `${window.location.origin}/api`;

export const getCart = query =>
  new Promise((resolve, reject) => {
    const _query = jsonToQuery(query);
    request.get(`${URL}/cart?${_query}`, { json: true }, (err, res, body) => {
      resolve(body);
    });
  });

export const insertCart = data =>
  new Promise((resolve, reject) => {
    request.post(
      `${URL}/cart`,
      { json: new Array(data) },
      (err, response, body) => {
        resolve(response);
      }
    );
  });

export const getDemo = query =>
  new Promise((resolve, reject) => {
    request.get(
      `${URL}/demo?${jsonToQuery(query)}`,
      { json: true },
      (err, res, { results, success, message }) => {
        if (success) resolve({ demo: results[0], success });
        else resolve({ success, message, demo: null });
      }
    );
  });

export const getDemos = query =>
  new Promise((resolve, reject) => {
    request.get(
      `${URL}/demos?${jsonToQuery(query)}`,
      { json: true },
      (err, res, { results, success, message }) => {
        if (success) resolve({ demos: results, success });
        else resolve({ success, message, demos: results });
      }
    );
  });

export const insertDemo = data =>
  new Promise((resolve, reject) => {
    request.post(
      `${URL}/demos`,
      { json: new Array(data) },
      (err, response, body) => {
        resolve(body);
      }
    );
  });

export const insertManyDemos = data => {
  request.post(`${URL}/demos`, { json: data }, logger);
};

export const updateDemo = data =>
  new Promise((resolve, reject) => {
    var options = {
      uri: `${URL}/demos`,
      body: JSON.stringify(data),
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      }
    };

    request(options, (err, response, body) => {
      resolve(body);
    });
  });

export const deleteDemo = id =>
  new Promise((resolve, reject) => {
    var options = {
      uri: `${URL}/demos`,
      body: JSON.stringify({ _id: id }),
      method: "DELETE",
      headers: {
        "Content-Type": "application/json"
      }
    };
    request(options, (err, response, body) => {
      resolve(body);
    });
  });

export const getAdminSettings = type =>
  new Promise(resolve => {
    request.get(
      `${URL}/admin/settings/${type}`,
      { json: true },
      (err, res, body) => {
        resolve({ result: body });
      }
    );
  });

export const getDefaultSettings = (params = []) =>
  new Promise(resolve => {
    const query = JSON.stringify(params);
    return request.get(
      `${URL}/admin/defaultSettings?params=${query}`,
      { json: true },
      (err, res, body) => {
        resolve(body);
      }
    );
  });

export const insertOrg = data =>
  new Promise((resolve, reject) => {
    request.post(
      `${URL}/org`,
      { json: new Array(data) },
      (err, response, body) => {
        resolve(body);
      }
    );
  });

export const updateOrg = data =>
  new Promise((resolve, reject) => {
    var options = {
      uri: `${URL}/org`,
      body: JSON.stringify(data),
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      }
    };

    request(options, (err, response, body) => {
      resolve(body);
    });
  });

export const getOrg = query =>
  new Promise((resolve, reject) => {
    const _query = jsonToQuery(query);
    request.get(`${URL}/org?${_query}`, { json: true }, (err, res, body) => {
      resolve(body);
    });
  });

export const getOrgs = data =>
  new Promise((resolve, reject) => {
    request.post(
      `${URL}/orgs`,
      { json: new Array(data) },
      (err, response, body) => {
        resolve(body);
      }
    );
  });

export const deleteOrg = id =>
  new Promise((resolve, reject) => {
    var options = {
      uri: `${URL}/org`,
      body: JSON.stringify({ _id: id }),
      method: "DELETE",
      headers: {
        "Content-Type": "application/json"
      }
    };
    request(options, (err, response, body) => {
      resolve(body);
    });
  });

export const getOrgSettings = () =>
  new Promise(resolve => {
    request.get(
      `${URL}/admin/orgSettings`,
      { json: true },
      (err, res, body) => {
        resolve(body);
      }
    );
  });

export const getAccess = query =>
  new Promise(resolve => {
    request.get(
      `${URL}/access?${jsonToQuery(query)}`,
      { json: true },
      (err, res, body) => {
        resolve(body);
      }
    );
  });

export const getRecord = (obj, query) =>
  new Promise((resolve, reject) => {
    request.get(
      `${URL}/${obj}?${jsonToQuery(query)}`,
      { json: true },
      (err, res, { success, results, message }) => {
        if (success) resolve({ result: results[0], success });
        else resolve({ success, results, message });
      }
    );
  });

export const getRecords = obj =>
  new Promise((resolve, reject) => {
    request.get(
      `${URL}/${obj}s?${jsonToQuery({})}`,
      { json: true },
      (err, res, { success, results, message, ...rez }) => {
        if (success) resolve({ result: results, success });
        else resolve({ success, results, message });
      }
    );
  });

export const insertRecord = (obj, data) =>
  new Promise((resolve, reject) => {
    request.post(
      `${URL}/${obj}`,
      { json: new Array(data) },
      (err, response, body) => {
        Event("RECORD_INSERTED", `${obj} ${data.id}`, `INSERTED_${obj}`);
        resolve(response);
      }
    );
  });

export const updateRecord = (obj, data) =>
  new Promise((resolve, reject) => {
    var options = {
      uri: `${URL}/${obj}`,
      body: JSON.stringify(data),
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      }
    };

    request(options, (err, response, body) => {
      Event("RECORD_UPDATED", `${obj} ${data.id}`, `UPDATED_${obj}`);
      resolve(body);
    });
  });

export const deleteRecord = (obj, { _id }) =>
  new Promise((resolve, reject) => {
    var options = {
      uri: `${URL}/${obj}`,
      body: JSON.stringify({ _id: _id }),
      method: "DELETE",
      headers: {
        "Content-Type": "application/json"
      }
    };
    request(options, (err, response, body) => {
      Event("RECORD_DELETED", `${obj} ${_id}`, `DELETED_${obj}`);
      resolve(body);
    });
  });

export default {
  deleteDemo,
  deleteOrg,
  deleteRecord,
  getAccess,
  getAdminSettings,
  getCart,
  getDefaultSettings,
  getDemo,
  getDemos,
  getOrg,
  getOrgs,
  getOrgSettings,
  getRecord,
  getRecords,
  insertCart,
  insertDemo,
  insertManyDemos,
  insertOrg,
  insertRecord,
  updateRecord,
  updateDemo,
  updateOrg
};
